import {
	ArrowLeft,
	ArrowRight,
	Bell,
	Book,
	Camera,
	Check,
	ChevronDown,
	ChevronRight,
	CircleAlert,
	CircleHelp,
	Coins,
	Cookie,
	Copy,
	CreditCard,
	Download,
	Ellipsis,
	Eye,
	EyeOff,
	Gift,
	Globe,
	GraduationCap,
	Home,
	Key,
	Laptop,
	LayoutGrid,
	LogOut,
	type LucideIcon,
	Mail,
	Menu,
	MessageCircle,
	Paperclip,
	Plane,
	RefreshCw,
	Scroll,
	Search,
	Settings,
	ShieldAlert,
	ShieldCheck,
	Smartphone,
	Smile,
	Sparkles,
	TriangleAlert,
	UserRound,
	UserRoundPlus,
	X,
} from "lucide-react";
import type { SVGProps } from "react";
import { cn } from "../lib/cn";

/**
 * Реестр иконок IEC ID. Ровно тот набор lucide, который встречается в макетах,
 * плюс служебные (глаз пароля, стрелки, троеточие) — расширять по мере
 * появления новых экранов, а не «на всякий случай»: каждый ключ попадает в бандл.
 */
export const icons = {
	ArrowLeft,
	ArrowRight,
	Bell,
	Book,
	Camera,
	Check,
	ChevronDown,
	ChevronRight,
	CircleAlert,
	CircleHelp,
	Coins,
	Cookie,
	Copy,
	CreditCard,
	Download,
	Ellipsis,
	Eye,
	EyeOff,
	Gift,
	Globe,
	GraduationCap,
	Home,
	Key,
	Laptop,
	LayoutGrid,
	LogOut,
	Mail,
	Menu,
	MessageCircle,
	Paperclip,
	Plane,
	RefreshCw,
	Scroll,
	Search,
	Settings,
	ShieldAlert,
	ShieldCheck,
	Smartphone,
	Smile,
	Sparkles,
	TriangleAlert,
	UserRound,
	UserRoundPlus,
	X,
} as const satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof icons;

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, "ref"> {
	/** Ключ из реестра. Взаимоисключим с `as`. */
	name?: IconName;
	/** Любая другая иконка lucide, если её нет в реестре. */
	as?: LucideIcon;
	/** 16 — метаданные и чипы, 20 — навигация и контролы, 32 — пустые состояния. */
	size?: number;
	strokeWidth?: number;
}

/**
 * Обёртка над lucide. Толщина штриха 1.5 (не дефолтные 2) — так набор
 * совпадает по весу с Geist при отсутствии жирных начертаний. Цвет всегда
 * наследуется через currentColor, поэтому у иконки нет собственного токена.
 */
export function Icon({ name, as, size = 20, strokeWidth = 1.5, className, ...rest }: IconProps) {
	const Glyph = as ?? (name ? icons[name] : undefined);
	if (!Glyph) return null;
	return (
		<Glyph
			width={size}
			height={size}
			strokeWidth={strokeWidth}
			aria-hidden="true"
			focusable="false"
			className={cn("shrink-0", className)}
			{...rest}
		/>
	);
}
